export const homeRoute = () => '/';
export const dashboardRoute = () => '/dashboard';
export const forgotPasswordRoute = () => '/forgot-password';
export const resetPasswordRoute = () => '/reset-password';
